module.exports = __webpack_public_path__ + "img/slide5.21c51060.jpg";